import { ProductType } from "./product-type";

export class SubsidyConfiguration {
  private productType: ProductType;
  private remainingPurchasePaymentMethod: number;
  private subsidyLimit: number;
  private allowSubsidyLimitExceed: boolean;
  private allowPurchaseUseReceipt: boolean;

  setProductType(value: ProductType): void {
    this.productType = value;
  }
  getProductType(): ProductType {
    return this.productType;
  }

  setRemainingPurchasePaymentMethod(value: number): void {
    this.remainingPurchasePaymentMethod = value;
  }
  getRemainingPurchasePaymentMethod(): number {
    return this.remainingPurchasePaymentMethod;
  }

  setSubsidyLimit(value: number): void {
    this.subsidyLimit = value;
  }
  getSubsidyLimit(): number {
    return this.subsidyLimit;
  }

  setAllowSubsidyLimitExceed(value: boolean): void {
    this.allowSubsidyLimitExceed = value;
  }
  getAllowSubsidyLimitExceed(): boolean {
    return this.allowSubsidyLimitExceed;
  }

  setAllowPurchaseUseReceipt(value: boolean): void {
    this.allowPurchaseUseReceipt = value;
  }
  getAllowPurchaseUseReceipt(): boolean {
    return this.allowPurchaseUseReceipt;
  }
}
